const parseCategoryId = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const categoryId = Number(value);
  return Number.isInteger(categoryId) ? categoryId : null;
};

const resolveSingleCategoryId = (items, field) => {
  const categoryIds = new Set(
    items
      .map((item) => parseCategoryId(item?.[field]))
      .filter((categoryId) => categoryId !== null)
  );
  return categoryIds.size === 1 ? Array.from(categoryIds)[0] : null;
};

// Client pricing is a quotation-level choice persisted on every line. The
// effective discount source cannot represent that choice: a zero-valued rule,
// a stronger manual discount or a promotion may legitimately win for a line.
const resolveQuotationClientPricingIntent = (items, quotation) => {
  if (quotation?.applyClientPricingCategoryDiscounts != null) {
    return {
      applyClientPricingCategoryDiscounts: quotation.applyClientPricingCategoryDiscounts,
      quoteClientPricingCategoryIds: quotation.quoteClientPricingCategoryIds ?? null,
    };
  }
  const safeItems = Array.isArray(items) ? items : [];
  const selection = safeItems.find((item) => Object.hasOwn(item || {}, 'quotationClientPricingCategoryIds'));
  if (selection) return {
    applyClientPricingCategoryDiscounts: !safeItems.some((item) => item?.quotationSkipClientPricing === true),
    quoteClientPricingCategoryIds: selection.quotationClientPricingCategoryIds,
  };
  const persistedCategoryId = resolveSingleCategoryId(
    safeItems,
    'quotationClientPricingCategoryId'
  );

  return {
    applyClientPricingCategoryDiscounts: !safeItems.some(
      (item) => item?.quotationSkipClientPricing === true
    ),
    quoteClientPricingCategoryId: persistedCategoryId
      ?? (safeItems.some((item) => Object.hasOwn(item || {}, 'quotationClientPricingCategoryId'))
        ? null : resolveSingleCategoryId(safeItems, 'clientPricingCategoryId')),
  };
};

export { resolveQuotationClientPricingIntent };
